module.exports = __webpack_public_path__ + "img/wxpay-logo.ef3ce279.png";